import React, { useState } from 'react';
import { Button, Menu, MenuItem, Typography } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const OrdenarDropdown = ({ cambiarOrdenamiento }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleSelect = (orden) => {
    cambiarOrdenamiento(orden);
    handleClose();
  };

  return (
    <div style={{ marginTop: '10px' }}>
      <Button
        onClick={handleClick}
        endIcon={<ArrowDropDownIcon />}
        style={{ background: '#23563F', textTransform: 'none' }}
     
      >
        <Typography style={{ fontFamily: 'Poppins', fontSize: '12px' }} className="bi filterOp">
          Ordenar
        </Typography>
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={() => handleSelect('precioMenor')}>
          Por precio (menor a mayor)
        </MenuItem>
        <MenuItem onClick={() => handleSelect('precioMayor')}>
          Por precio (mayor a menor)
        </MenuItem>
        <MenuItem onClick={() => handleSelect('nombreA')}>
          Por nombre (A-Z)
        </MenuItem>
        <MenuItem onClick={() => handleSelect('nombreZ')}>
          Por nombre (Z-A)
        </MenuItem>
      </Menu>
    </div>
  );
};

export default OrdenarDropdown;
